import { EmptyState } from "../ui/EmptyState";

export function FeatureDisabledState({
  title,
}: {
  title: string;
}) {
  return (
    <EmptyState eyebrow="Feature disabled" title={title}>
      This workspace feature is not enabled for the current package or user.
    </EmptyState>
  );
}
